import { Injectable } from '@angular/core';

/**
 * Cache số liệu 2 widget header (chuông thông báo + tiến trình xử lý):
 * header bị destroy/tạo lại mỗi lần chuyển tab (routeReuseStrategy=false) nên
 * component mới khởi tạo badge rỗng rồi chờ API về mới có số -> nháy.
 * Service singleton giữ giá trị lần fetch gần nhất: component mới đọc ra hiện
 * ngay số cũ, API vẫn gọi bình thường nhưng chỉ gán lại UI khi kết quả khác cache.
 */
@Injectable({
  providedIn: 'root'
})
export class HeaderCountService {
  notifies: any[] = null;
  totalUnread: number = null;
  processes: any[] = null;
  totalProcesses: number = null;

  // true nếu khác cache (caller gán lại UI); false nếu giống (bỏ qua để không re-render)
  setNotifyData(notifies: any[], totalUnread: number): boolean {
    if (this.totalUnread === totalUnread && this.shallowEqualArray(this.notifies, notifies)) {
      return false;
    }
    this.notifies = notifies;
    this.totalUnread = totalUnread;
    return true;
  }

  setProcessingData(totalProcesses: number, processes: any[]): boolean {
    if (this.totalProcesses === totalProcesses && this.shallowEqualArray(this.processes, processes)) {
      return false;
    }
    this.totalProcesses = totalProcesses;
    this.processes = processes;
    return true;
  }

  reset() {
    this.notifies = null;
    this.totalUnread = null;
    this.processes = null;
    this.totalProcesses = null;
  }

  // so sánh các trường badge hiển thị: id + status (thông báo) / code, percent, status (lot)
  private shallowEqualArray(a: any[], b: any[]): boolean {
    if (a === b) { return true; }
    if (!a || !b || a.length !== b.length) { return false; }
    for (let i = 0; i < a.length; i++) {
      if (!a[i] || !b[i]) { return a[i] === b[i]; }
      if (a[i].id !== b[i].id || a[i].status !== b[i].status) { return false; }
      if (a[i].percent !== undefined && b[i].percent !== undefined && a[i].percent !== b[i].percent) { return false; }
    }
    return true;
  }
}
